import React, { memo, useEffect, useState, useRef, useCallback } from "react";
import "./productCard.css";

function ProductCard() {
  const [displayedCards, setDisplayedCards] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const isAnimatingRef = useRef(false);

  const allCards = useRef([
    {
      id: 1,
      imgUrl: "/images/footerimageOne.svg",
      apiName: "Udyam",
      successMsg: "registration verified",
      timeStamp: "just now",
    },
    {
      id: 2,
      imgUrl: "/images/footerCardImagetwo.svg",
      apiName: "LPG connection",
      successMsg: "verified",
      timeStamp: "1 second ago",
    },
    {
      id: 3,
      imgUrl: "/images/rcimage-productcard.svg",
      apiName: "RC Details",
      successMsg: "verified",
      timeStamp: "3 second ago",
    },
    {
      id: 4,
      imgUrl: "/images/footerCardImageFour.svg",
      apiName: "Aadhaar",
      successMsg: "details validated",
      timeStamp: "6 second ago",
    },
    {
      id: 5,
      imgUrl: "/images/footerCardImageFive.svg",
      apiName: "Telco Details",
      successMsg: "verification Successful",
      timeStamp: "6 second ago",
    },
    {
      id: 6,
      imgUrl: "/images/footerCardImageSix.svg",
      apiName: "Document OCR",
      successMsg: "details received",
      timeStamp: "6 second ago",
    },
    {
      id: 7,
      imgUrl: "/images/passportimage-productcard.svg",
      apiName: "Passport",
      successMsg: "verified Successfully",
      timeStamp: "6 second ago",
    },
    {
      id: 8,
      imgUrl: "/images/employmenthistory-productcard.svg",
      apiName: "Employment History",
      successMsg: "retrieved",
      timeStamp: "just now",
    },
    {
      id: 9,
      imgUrl: "/images/rcimage-productcard.svg",
      apiName: "RC Details",
      successMsg: "Verified",
      timeStamp: "6 second ago",
    },
    {
      id: 10,
      imgUrl: "/images/vpaanalysis-productcard.svg",
      apiName: "VPA Analysis",
      successMsg: "completed",
      timeStamp: "6 second ago",
    },
  ]).current;

  useEffect(() => {
    setDisplayedCards(
      allCards
        .slice(0, 4)
        .map((card, index) => ({ ...card, isNew: index === 0 }))
    );
  }, []);

  const updateCards = useCallback(() => {
    if (isAnimatingRef.current) return;

    isAnimatingRef.current = true;

    setDisplayedCards((prevCards) => {
      const nextIndex = (currentIndex + 1) % allCards.length;
      setCurrentIndex(nextIndex);

      return [
        { ...allCards[nextIndex], timeStamp: getRandomTimeAgo(), isNew: true },
        ...prevCards.slice(0, 3).map((card) => ({ ...card, isNew: false })),
      ];
    });

    let timer = setTimeout(() => {
      isAnimatingRef.current = false;
    }, 500);

    return () => clearTimeout(timer);
  }, [currentIndex]);

  useEffect(() => {
    const interval = setInterval(updateCards, 2000);
    return () => clearInterval(interval);
  }, [updateCards]);

  return (
    <div className="phone-screen">
      <div className="cards-container">
        {displayedCards.map((card, index) => (
          <Card key={`${card.id}-${index}`} content={card} isNew={card.isNew} />
        ))}
      </div>
    </div>
  );
}

export default memo(ProductCard);

const Card = memo(({ content, isNew }) => {
  return (
    <div className={`product-card ${isNew ? "new-card" : ""}`}>
      <img
        src={content.imgUrl}
        alt={content.apiName}
        className="card-image"
        loading="lazy"
        decoding="async"
      />
      <div className="card-content">
        <div className="card-box">
          <span className="card-highlight">{content.apiName}</span>
          <h3 className="card-heading">{content.successMsg}</h3>
        </div>
        <span className="card-timestamp">{content.timeStamp}</span>
      </div>
    </div>
  );
});

function getRandomTimeAgo() {
  const randomSeconds = Math.floor(Math.random() * 31);
  return randomSeconds === 0
    ? "just now"
    : `${randomSeconds} second${randomSeconds > 1 ? "s" : ""} ago`;
}
